import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../shared/components/Button';
import OauthButton from '../../../../../shared/components/OauthButton/OauthButton';
import { useSelector } from 'react-redux';

const YouTubeAuth = ({
  nextStep
}) => {
  const { t } = useTranslation();
  const testFlow = useSelector(state => state.config.test);

  return <div>

    <h3 className='mb-4'>
      {t('influencers.pages.campaign.apply_side_pane.youtube_connect.connect_to_obviously')}
    </h3>

    <div className="text-2 mb-3">
      {t('influencers.pages.campaign.apply_side_pane.youtube_connect.connect_to_desc')}
    </div>

    <a href="https://support.google.com/accounts/answer/10130420?hl=en&ref_topic=7188760">
      {t('influencers.pages.campaign.apply_side_pane.youtube_connect.learn_more')}
    </a>

    <hr className='my-6' />
    <Row className='justify-content-end'>
      <Col className="col-auto">
        <ButtonGroup className="non-adaptable">
          {
            testFlow.includes('fb_optional')
              ? <Button
                variant='primary'
                onClick={() => {
                  const { origin, pathname } = window.location;
                  const queryParams = new URLSearchParams({
                    'youtube_oauth_callback': testFlow.includes('yt_success'),
                    'test_flow': `yt${testFlow.includes('yt_success') ? ',yt_success' : ',yt_error'}`
                  });
                  window.location.replace(`${origin}${pathname}?${queryParams.toString()}`);
                }}>
                {t('influencers.common.connect')}
              </Button>
              : <OauthButton platform="youtube_publication"
                text={t('influencers.pages.campaign.apply_side_pane.connect_youtube_yes')} />
          }
          <Button
            variant="secondary"
            type="button"
            onClick={() => nextStep({
              connectFacebook: testFlow.includes('fb_optional')
            })} >
            {t('influencers.pages.campaign.apply_side_pane.connect_youtube_no')}
          </Button>
        </ButtonGroup>
      </Col>
    </Row>
  </div>;
};

YouTubeAuth.propTypes = {
  nextStep: PropTypes.func.isRequired
};
export default YouTubeAuth;
